import DecimalJs from 'decimal.js';

/**
 * Десятичная арифметика для промежуточных расчётов с деньгами.
 * Точность — 40 значащих цифр, округление по умолчанию — половина от нуля.
 * Экспоненциальная запись в строках отключена в разумном диапазоне.
 */
export const Decimal = DecimalJs.clone({
  precision: 40,
  rounding: DecimalJs.ROUND_HALF_UP,
  toExpNeg: -30,
  toExpPos: 40,
});
export type Decimal = InstanceType<typeof Decimal>;
export type DecimalInput = Decimal | number | string;

export function dec(value: DecimalInput): Decimal {
  if (typeof value === 'number' && !Number.isFinite(value)) {
    throw new RangeError(`Ожидалось конечное число, получено ${String(value)}`);
  }
  return new Decimal(value);
}

export const ROUND_HALF_UP = DecimalJs.ROUND_HALF_UP;
export const ROUND_CEIL = DecimalJs.ROUND_CEIL;
